/**
 * Well-known section identities used to locate sections across templates.
 */
export enum StandardisedSectionName {
  RiskDetails = 'risk_details',
  Information = 'information',
  SecurityDetails = 'security_details',
  SubscriptionAgreement = 'subscription_agreement',
  FiscalAndRegulatory = 'fiscal_and_regulatory',
  BrokerRemunerationAndDeductions = 'broker_remuneration_deductions',
}
